import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  BrandSelector,
  type BrandSelectorProps,
} from '~/components/features/BrandSelector'
import { type Brand } from '~/hooks/useBrandAccountQuery'
import { useFormField } from '~/hooks/useFormField'
import { useLogEvent } from '~/hooks/useLogEvent'
import { findByPath } from '~/utils'

import { useSurvey } from '../hooks/useSurvey'
import { type InputValues } from '../utils'

export const BrandInput = () => {
  const { t } = useTranslation()
  const { control, watch } = useFormContext<InputValues>()
  const brandIdField = useFormField(control, 'brandId')

  const survey = useSurvey()
  const brandGroupId = watch('brandGroupId')
  const brands = React.useMemo(() => {
    const brandGroup = findByPath(survey?.brandGroups ?? [], 'id', brandGroupId)

    return brandGroup?.brands ?? []
  }, [brandGroupId, survey?.brandGroups])

  const logEvent = useLogEvent()
  const handleChange = React.useCallback<
    EH<BrandSelectorProps<Brand>, 'onChange'>
  >(
    (brandId) => {
      brandIdField.onChange(brandId)
      logEvent('Select brand', { withSuffix: true })
    },
    [brandIdField, logEvent],
  )

  return (
    <LabelingContainer label={t('brand_name')}>
      <BrandSelector
        brands={brands}
        width={160}
        {...brandIdField}
        onChange={handleChange}
      />
    </LabelingContainer>
  )
}
